import { Box } from '@hivebrite/design-system/Box';
import { SimpleCard } from '@hivebrite/design-system/SimpleCard';

interface ErrorCardProps {
  title: string;
  description?: string;
}

const ErrorCard = ({ title, description }: ErrorCardProps) => (
  <Box
    width="100%"
    height="100%"
    alignItems="center"
    justifyContent="center"
    py="120px"
  >
    <SimpleCard
      title={title}
      description={description}
      faIconProps={{
        iconName: 'robot',
      }}
      cardProps={{ maxWidth: '820px' }}
    />
  </Box>
);

export { ErrorCard };
